export const PREMIUM_DBS_LEARN_MORE_URL =
  'https://help.hostfully.com/en/collections/19741965-coming-soon-premium-direct-booking-site';

// Marketing's upgrade experience. The query string is part of the destination — it selects
// the experiment variant and the product — so it must survive verbatim.
export const PREMIUM_DBS_CONTACT_SALES_URL =
  'https://www.hostfully.com/customer-upgrade/?q_showExperience=experience-1784640048740&main_product=assist';
